import * as ko from "knockout";
import { request_dto as originalRequest } from "./request_dto";
import { c_request_subscription_view } from "../../original/c_request_subscription_view";
import * as _ from "lodash";
import { c_wty_claim_defective_part } from "../../original";
import { CustomObservables } from "CustomObservables";
import { person, product, task_management_extended } from "organized";
import labels from "app/labels";

export class extended_request extends originalRequest {
  customer_ref: KnockoutObservable<string>;
  prioColor: KnockoutComputed<string>;
  subscribed: KnockoutObservable<boolean>;
  isCollapsed: KnockoutObservable<boolean>;
  att_notifications: KnockoutObservable<any>;
  notes_notifications: KnockoutObservable<any>;
  originalPriority: KnockoutObservable<any>;
  isCompleted: KnockoutObservable<boolean>;
  canInteract: KnockoutObservable<boolean>;
  isEscalated: KnockoutComputed<boolean>;
  escalation_status: KnockoutObservable<any>;
  c_request_subscription_view: KnockoutObservableArray<c_request_subscription_view>;
  c_wty_claim_defective_part: KnockoutObservableArray<c_wty_claim_defective_part>;
  ext_portal_req_subtype: KnockoutObservable<string>;
  noteCount: KnockoutObservable<number>;
  attCount: KnockoutObservable<number>;
  toner_color_c_check: KnockoutComputed<boolean>;
  toner_waste_check: KnockoutComputed<boolean>;
  toner_color_m_check: KnockoutComputed<boolean>;
  toner_color_y_check: KnockoutComputed<boolean>;
  toner_color_k_check: KnockoutComputed<boolean>;
  canResubmit: KnockoutObservable<boolean>;
  selectedProduct: KnockoutObservable<product>;
  reqextens_user_def1: KnockoutObservable<string>;
  reqextens_user_def2: KnockoutObservable<string>;
  reqextens_user_def3: KnockoutObservable<string>;
  reqextens_user_def4: KnockoutObservable<string>;
  reqextens_user_def10: KnockoutObservable<string>;
  reqextens_user_def12: KnockoutObservable<string>;
  dead_line: KnockoutObservable<Date>;
  formatteddead_line: any;
  end_user: KnockoutObservable<any>;
  project_size: KnockoutObservable<any>;
  connection: KnockoutObservable<any>;
  phenomenon: KnockoutObservable<any>;
  reproduce: KnockoutObservable<any>;
  expected_result: KnockoutObservable<any>;
  conclusion: KnockoutObservable<any>;
  main_counter: KnockoutObservable<any>;
  software_version_no: KnockoutObservable<any>;
  hasSoftware: KnockoutComputed<string>;
  hasHardware: KnockoutComputed<any>;
  operating_system: KnockoutObservable<string>;
  business_descr: KnockoutObservable<string>;
  firmware: KnockoutObservable<string>;
  network_interface: KnockoutObservable<string>;
  counterColorRequired: KnockoutObservable<boolean>;
  person: KnockoutObservable<person>;
  task: KnockoutObservable<task_management_extended>;
  rowColor: KnockoutComputed<string>;
  incidentTextColor: KnockoutComputed<string>;
  other_incident_code: KnockoutObservable<string>;

  constructor(item?: any) {
    super(item);

    this.customer_ref = ko.observable(item?.customer_ref);
    this.noteCount = ko.observable();
    this.attCount = ko.computed(() => {
      return this.request_attachment().length;
    });

    if (item?.c_person_request_subscription) {
      if (Array.isArray(item?.c_person_request_subscription)) {
        this.subscribed = ko.observable(item?.c_person_request_subscription.length > 0);
      } else {
        this.subscribed = ko.observable(item?.c_person_request_subscription != undefined);
      }
    } else {
      this.subscribed = ko.observable(false);
    }

    this.isCollapsed = ko.observable(true);
    this.other_incident_code = ko.observable();
    this.escalation_status = ko.observable(item?.escalation_status);
    this.originalPriority = ko.observable(item?.user_def8);
    this.prioColor = ko.pureComputed(() => {
      switch (item?.user_def8 ?? "0") {
        case "6":
          return "#FF0000";
        case "1":
          return "#FF6A00";
        case "2":
          return "#FFD800";
        case "3":
          return "#FFE97F";
        case "4":
          return "#4CFF00";
        case "5":
          return "#0094FF";
      }
      return "#fff";
    });
    let notes_notifications;
    let att_notifications;
    if (item) {
      this.c_request_subscription_view = <KnockoutObservableArray<c_request_subscription_view>>(
        this.loadRelation(item, c_request_subscription_view, "c_request_subscription_view", "array")
      );
      notes_notifications = _.find(this.c_request_subscription_view(), (item) => {
        return item?.update_type() == "NOTE";
      });
      att_notifications = _.find(this.c_request_subscription_view(), (item) => {
        return item?.update_type() == "ATTACHMENT";
      });
    }
    let notification_array = new Array();
    if (item?.task && Array.isArray(item?.task)) {
      notification_array = _.flatMap(item.task, (o) => {
        return [o.ext_new_note_for_customer, o.ext_new_note_for_partner];
      });
      notification_array.push(item?.ext_new_note_for_customer);
      notification_array.push(item?.ext_new_note_for_partner);
    } else if (item?.task) {
      notification_array = [
        item?.ext_new_note_for_customer,
        item?.ext_new_note_for_partner,
        item?.task?.ext_new_note_for_customer,
        item?.task?.ext_new_note_for_partner,
      ];
    }
    let new_notes_notifications = notification_array.some((o) => o === "Y");

    this.notes_notifications = ko.observable(
      (notes_notifications && notes_notifications.counter()) || new_notes_notifications || null
    );
    notification_array = new Array();
    if (item?.task && Array.isArray(item?.task)) {
      notification_array = _.map(item.task, (o) => {
        return o.ext_new_public_attachment;
      });
      notification_array.push(item?.ext_new_public_attachment);
    } else if (item?.task) {
      notification_array = [item?.ext_new_public_attachment, item?.task?.ext_new_public_attachment];
    }
    let new_attachment_notifications = notification_array.some((o) => o === "Y");
    this.att_notifications = ko.observable(
      (att_notifications && att_notifications.counter()) || new_attachment_notifications || null
    );
    this.isEscalated = ko.pureComputed(() => {
      if (this.escalation_status()) {
        return !(this.escalation_status() == "NONE");
      } else {
        return false;
      }
    });
    this.canInteract = ko.observable(!_.includes(["CA", "CL", "CO"], item?.status));
    this.isCompleted = ko.observable(item?.status == "CO");

    this.toner_color_c_check = ko.pureComputed({
      read: () => {
        return this.toner_color_c() && this.toner_color_c() == "Y";
      },
      write: (value: boolean) => {
        this.toner_color_c(value ? "Y" : "N");
      },
    });
    this.toner_color_m_check = ko.pureComputed({
      read: () => {
        return this.toner_color_m() && this.toner_color_m() == "Y";
      },
      write: (value: boolean) => {
        this.toner_color_m(value ? "Y" : "N");
      },
    });
    this.toner_color_y_check = ko.pureComputed({
      read: () => {
        return this.toner_color_y() && this.toner_color_y() == "Y";
      },
      write: (value: boolean) => {
        this.toner_color_y(value ? "Y" : "N");
      },
    });
    this.toner_color_k_check = ko.pureComputed({
      read: () => {
        return this.toner_color_k() && this.toner_color_k() == "Y";
      },
      write: (value: boolean) => {
        this.toner_color_k(value ? "Y" : "N");
      },
    });
    this.toner_waste_check = ko.pureComputed({
      read: () => {
        return this.toner_waste() && this.toner_waste() == "Y";
      },
      write: (value: boolean) => {
        this.toner_waste(value ? "Y" : "N");
      },
    });
    this.canResubmit = ko.observable(localStorage.getItem(this.request_id()) === "canResubmit");
    if (item) {
      this.selectedProduct = <KnockoutObservable<product>>this.loadRelation(item, product, "product", "single");
    }

    this.reqextens_user_def1 = ko.observable(item?.reqextens_user_def1);
    this.reqextens_user_def2 = ko.observable(item?.reqextens_user_def2);
    this.reqextens_user_def3 = ko.observable(item?.reqextens_user_def3);
    this.reqextens_user_def4 = ko.observable(item?.reqextens_user_def4);
    this.reqextens_user_def10 = ko.observable(item?.reqextens_user_def10).extend({ maxLength: 15 });
    this.reqextens_user_def12 = ko.observable(item?.reqextens_user_def12);

    this.dead_line = ko.observable(this.formatJSONDate(item?.dead_line));
    this.end_user = ko.observable(item?.end_user);
    this.project_size = ko.observable(item?.project_size).extend({
      maxLength: 50,
    });
    this.formatteddead_line = CustomObservables.formattedDateTimeObservable(this.dead_line);
    this.connection = ko.observable(item?.connection);
    this.phenomenon = ko.observable(item?.phenomenon).extend({ required: true, maxLength: 32000 });
    this.reproduce = ko.observable(item?.reproduce).extend({ required: true, maxLength: 32000 });
    this.expected_result = ko.observable(item?.expected_result).extend({ required: true, maxLength: 32000 });
    this.conclusion = ko.observable(item?.conclusion).extend({ required: true, maxLength: 32000 });
    this.main_counter = ko
      .observable(item?.main_counter)
      .extend({ digit: { params: true, message: labels.descr("cc_P_PLEASE_ENTER_VALID_NR") }, max: 999999999 });
    this.software_version_no = ko.observable(item?.software_version_no).extend({ required: true });
    this.hasHardware = ko.pureComputed(() => {
      return this.user_def9() || this.user_def2();
    });
    this.hasSoftware = ko.pureComputed(() => {
      return this.reqextens_user_def3();
    });
    this.operating_system = ko.observable(item?.operating_system);
    this.business_descr = ko.observable(item?.business_descr).extend({ maxLength: 250 });
    this.firmware = ko.observable(item?.firmware);
    this.network_interface = ko.observable(item?.network_interface);
    this.counterColorRequired = ko.observable();

    this.ext_portal_req_subtype = ko.observable(item?.ext_portal_req_subtype);

    this.person = <KnockoutObservable<person>>this.loadRelation(item, person, "person");
    this.task = <KnockoutObservable<task_management_extended>>this.loadRelation(item, task_management_extended, "task");

    this.rowColor = ko.pureComputed(() => {
      switch (this.req_group()) {
        case "LOCAL - NOT SUBMITTED": {
          if (this.req_status() === "COMPLETE") {
            return "#c5e0b4";
          }
          if (this.req_status() === "OPEN") {
            return "#fcd4d4";
          }
        }
        default: {
          return null;
        }
      }
    });

    this.incidentTextColor = ko.pureComputed(() => {
      switch (this.req_group()) {
        case "LOCAL - NOT SUBMITTED": {
          if (this.req_status() === "CANCELED") {
            return "#909090";
          }
          return "black";
        }
        default: {
          return "black";
        }
      }
    });
  }
}
